import { Controller, get } from "react-hook-form";
import { FocusEvent } from "react";
import { TextField } from "../../ui";

export interface InputProps {
  name: string;
  label: string;
  methods: any;
  helperText?: string;
  disabled?: boolean;
  onBlur?: (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  // Prop aceita por compatibilidade (o erro real vem do Controller do RHF)
  error?: boolean;
}

export default function InputData({
  name,
  label,
  methods,
  helperText,
  disabled,
  onBlur,
}: InputProps) {
  return (
    <Controller
      name={name}
      control={methods.control}
      render={({ field, formState: { errors } }) => {
        const error = get(errors, name);
        return (
          <TextField
            {...field}
            label={label}
            helperText={error?.message || helperText}
            error={!!error}
            type="date"
            disabled={disabled}
            onBlur={onBlur || field.onBlur}
            onChange={(e) => {
              const val = e.target.value;
              if (typeof val === "string") {
                field.onChange(val.replace(/-/g, "/"));
              } else {
                field.onChange(val);
              }
            }}
            value={typeof field.value === "string" ? field.value.replace(/\//g, "-") : ""}
          />
        );
      }}
    />
  );
}
